import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AdminSidebar = ({ collapsed, onToggle }) => {
    const location = useLocation();

    const menuItems = [
        {
            id: 'dashboard',
            label: 'Dashboard',
            icon: '📊',
            path: '/admin',
            color: 'text-blue-600'
        },
        {
            id: 'users',
            label: 'User Management',
            icon: '👥',
            path: '/admin/users',
            color: 'text-green-600'
        },
        {
            id: 'analytics',
            label: 'Analytics',
            icon: '📈',
            path: '/admin/analytics',
            color: 'text-purple-600'
        },
        {
            id: 'content',
            label: 'Content Management',
            icon: '📝',
            path: '/admin/content',
            color: 'text-orange-600'
        },
        {
            id: 'security',
            label: 'Security',
            icon: '🔒',
            path: '/admin/security',
            color: 'text-red-600'
        },
        {
            id: 'system',
            label: 'System',
            icon: '⚙️',
            path: '/admin/system',
            color: 'text-gray-600'
        },
        {
            id: 'settings',
            label: 'Settings',
            icon: '🔧',
            path: '/admin/settings',
            color: 'text-indigo-600'
        }
    ];

    const isActive = (path) => {
        return location.pathname === path || location.pathname.startsWith(path + '/');
    };

    return (
        <div className={`bg-white shadow-lg border-r border-gray-200 transition-all duration-300 ${
            collapsed ? 'w-16' : 'w-64'
        }`}>
            {/* Header */}
            <div className="p-4 border-b border-gray-200">
                <div className="flex items-center justify-between">
                    {!collapsed && (
                        <h2 className="text-xl font-bold text-gray-900">Admin Panel</h2>
                    )}
                    <button
                        onClick={onToggle}
                        className="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                    >
                        <svg 
                            className={`w-5 h-5 text-gray-600 transition-transform duration-200 ${
                                collapsed ? 'rotate-180' : ''
                            }`} 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                        </svg>
                    </button>
                </div>
            </div>

            {/* Navigation */}
            <nav className="p-4 space-y-2">
                {menuItems.map((item) => (
                    <Link
                        key={item.id}
                        to={item.path}
                        className={`flex items-center px-3 py-2 rounded-lg transition-all duration-200 group ${
                            isActive(item.path)
                                ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                        }`}
                    >
                        <span className={`text-xl ${collapsed ? 'mx-auto' : 'mr-3'}`}>
                            {item.icon}
                        </span>
                        {!collapsed && (
                            <span className="font-medium">{item.label}</span>
                        )}
                        {!collapsed && isActive(item.path) && (
                            <div className="ml-auto w-2 h-2 bg-blue-600 rounded-full"></div>
                        )}
                    </Link>
                ))}
            </nav>

            {/* Footer */}
            {!collapsed && (
                <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
                    <div className="text-xs text-gray-500 text-center">
                        Menuwise Admin v1.0
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminSidebar;





